// extracted by mini-css-extract-plugin
export var card = "_vr-0";
export var details = "_vr-1";